import type { PublishedMetadata } from '@tempo-io/roadmap-dto';
import type { PublishingPreferences } from '../published/types';

export interface ExportSearchParams {
  title?: string;
  branding?: string;
  date?: string;
  legend?: string;
  vision?: string;
  transparent?: string;
}

export function getExportFileName(
  viewName: string | undefined,
  visualizationType: 'swimlane' | 'timeline',
): string {
  return viewName?.trim() || `${visualizationType}-export`;
}

export function getBooleanQueryParam(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined) return defaultValue;
  return value === '1';
}

export function getEffectivePreferences(
  metadata: PublishedMetadata,
  searchParams: ExportSearchParams,
): PublishingPreferences {
  return {
    ...metadata.preferences,
    showTitle: getBooleanQueryParam(searchParams.title, true),
    showTempoBranding: getBooleanQueryParam(searchParams.branding, true),
    showPublishDate: getBooleanQueryParam(searchParams.date, true),
    showLegend: getBooleanQueryParam(searchParams.legend, true),
    showVisionStatement:
      searchParams.vision !== undefined
        ? true
        : (metadata.preferences?.showVisionStatement ?? false),
  };
}
